<template>
    <div>
        
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">分成规则</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <!-- <el-form-item label="主屏id">
                <el-input size="small" v-model="formInline.machineId" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="激活时间">
                <el-date-picker
                    v-model="formInline.time"
                    type="daterange"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item> -->
            <el-form-item label="商家角色">
                <el-select v-model="formInline.role" @change="selectChange">
                    <el-option label="总经销商" value="1"></el-option>
                    <el-option label="推广员" value="3"></el-option>
                    <el-option label="商家" value="5"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="formInline.role !== ''" :label="roleName">
                <el-select v-model="bindDistributorId" filterable placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.nickname"
                    :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label=" ">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small"  @click="resetting">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" row-key="id" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column  prop="divisionSystem" label="平台比例" >
        </el-table-column>
        <el-table-column  prop="distributorName" label="总经销商名称">
        </el-table-column>
        <el-table-column  prop="divisionDistributor" label="总经销商分成比例">
        </el-table-column>
        <el-table-column  prop="promoterName" label="推广员名称">
        </el-table-column>
        <el-table-column  prop="divisionPromoter" label="推广员分成比例">
        </el-table-column>
        <el-table-column  prop="storeName" label="商家名称">
        </el-table-column>
        <el-table-column  prop="divisionStore" label="商家分成比例">
        </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="40%" @click="closeDialog">
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane :label="'主屏'" name="host">
                    <el-descriptions title="基本信息">
                        <el-descriptions-item label="主屏id">{{seeForm.machineId}}</el-descriptions-item>
                        <el-descriptions-item label="mac地址">{{seeForm.mac}}</el-descriptions-item>
                        <el-descriptions-item label="App版本号">{{seeForm.appVersion}}</el-descriptions-item>
                        <el-descriptions-item label="设备类型">{{seeForm.machineType == 1?'主屏':'手屏'}}</el-descriptions-item>
                        <el-descriptions-item label="内存">{{seeForm.ram}}</el-descriptions-item>
                        <el-descriptions-item label="屏幕分辨率">{{seeForm.resolution}}</el-descriptions-item>
                        <el-descriptions-item label="累计开机时长">{{seeForm.totalUptime}}</el-descriptions-item>
                        <el-descriptions-item label="激活时间">{{seeForm.activatedAt|timestampToTime}}</el-descriptions-item>
                        <el-descriptions-item label="所在地区">{{seeForm.address}}</el-descriptions-item>
                        <el-descriptions-item label="系统模式">{{seeForm.billingMode == 1?'计费':'免费'}}</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                <el-tab-pane v-for="(item , index) in seeForm.machines" :key="item.id" :label="'手屏' + (index + 1)" :name="item.id">
                    <el-descriptions title="基本信息">
                        <el-descriptions-item label="主屏id">{{item.machineId}}</el-descriptions-item>
                        <el-descriptions-item label="mac地址">{{item.mac}}</el-descriptions-item>
                        <el-descriptions-item label="App版本号">{{item.appVersion}}</el-descriptions-item>
                        <el-descriptions-item label="设备类型">{{item.machineType == 1?'主屏':'手屏'}}</el-descriptions-item>
                        <el-descriptions-item label="内存">{{item.ram}}</el-descriptions-item>
                        <el-descriptions-item label="屏幕分辨率">{{item.resolution}}</el-descriptions-item>
                        <el-descriptions-item label="累计开机时长">{{item.totalUptime}}</el-descriptions-item>
                        <el-descriptions-item label="激活时间">{{item.activatedAt|timestampToTime}}</el-descriptions-item>
                        <el-descriptions-item label="所在地区">{{item.address}}</el-descriptions-item>
                        <el-descriptions-item label="系统模式">{{item.billingMode == 1?'计费':'免费'}}</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                <!-- <el-tab-pane :label="labelNameAssistant2" name="Assistant2">配置管理</el-tab-pane>
                <el-tab-pane :label="labelNammeeAssistant3" name="Assistant3">配置管理</el-tab-pane>
                <el-tab-pane :label="labelNameAssistant4" name="Assistant4">配置管理</el-tab-pane> -->
            </el-tabs>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">关 闭</el-button>
            </div>
        </el-dialog>
        
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadDivisionList , getStoreUserList } from '../../../api/userMG'
export default {
    data(){
        return{
            bindDistributorId:'',
            seeForm:{},
            activeName:'host',
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                machineId: '',
                nickName: '',
                time:[],
                role:''
            },
            listData: [
                    
            ],
            //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            roleName:''
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        selectChange(){
            this.bindDistributorId = ''
            if(this.formInline.role == 1){
                this.roleName  = '总经销商'
                getStoreUserList({userType:1}).then(res=>{
                    this.options = res.storeUsers
                })
            }else if(this.formInline.role == 3){
                this.roleName  = '推广员'
                getStoreUserList({userType:3}).then(res=>{
                    this.options = res.storeUsers
                })
            }else{
                this.roleName  = '商家'
                getStoreUserList({userType:5}).then(res=>{
                    this.options = res.storeUsers
                })
            }
        },
        seeClick(row){
            console.log(row)
            this.seeForm = row
            this.activeName = 'host'
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        search(){
            console.log(this.formInline)
            this.getdata()
        },
        resetting(){
            this.formInline = {
                page:1,
                limit:10,
                machineId:'',
                time:[],
                role:''
            }
            this.getdata()
        },
        getdata(){
            loadDivisionList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                type:this.formInline.role,
                id:this.bindDistributorId,
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/SiteManagement/divideInto/index.vue